import loadJS from '@/helpers/loadJS'

window.$ = window.$ || window.jQuery || undefined

/* eslint-disable */
function BMS_calendar() {
  const API_URL_ROOT = 'https://vacation.unicstay.com/api/v1'
  const ASSETS_URL = 'https://unicstay-widgets.s3.fr-par.scw.cloud/unicstay-widgets-0.2.1/dist/assets'
  this.assets_url = ASSETS_URL
  this.jQueryScriptOutputted = false
  this.api_url_root = ''
  this.api_url_unavailabilities_base = '/services/yyyyy/unavailabilitycalendar/'
  this.api_url_unavailabilities = ''
  this.api_url_units = '/providers/xxxxx/services/yyyyy/units/'
  this.api_url_offers = '/providers/xxxxx/offers/'
  this.api_url_booking_preview = '/bookings/preview/'
  this.api_url_limits = '/services/yyyyy/conditioncalendar?start=start_date_data&end=end_date_data'
  this.booking_url = ''
  this.booking_url_params = '/service_slug/1?initial_1a_start_date=start_date_data&initial_1a_end_date=end_date_data&initial_2a_adults_number=adults_cnt&initial_2a_children_number=children_cnt&initial_2a_infants_number=infants_cnt'
  this.provider = null
  this.provider_from_api = null
  this.provider_slug = ''
  this.service = null
  this.service_from_api = null
  this.service_slug = ''
  this.months = null
  this.months_count = null
  this.months_container = null
  this.container = null
  this.form_container = null
  this.selection_start = null
  this.selection_end = null
  this.marketplace_from_api = null
  this.mkt_slug = ''
  this.mkt_cname = ''
  this.sales_mode = '' // use marketplace url or directsales etc
  this.adults = 1
  this.children = 0
  this.infants = 0
  this.exact_nights_number = false
  this.color = {
    background: null,
  }
  this.provider_key = null
  this.unavailabilities = []
  this.availabilities = []
  this.units = [] //this stores units from api
  this.unit_availabilities = [] //this stores units which store months that contain free days arrays
  this.reservation = {
    start: null,
    end: null,
    unit: null,
  }
  this.click_switch = false
  this.offers = []
  this.locale = 'fr'
  this.window = {
    width: 0,
    height: 0,
  }
  this.resize_enabled = false
  this.fit_width = false
  this.fit_height = false
  this.disable_booking = false
  this.translations = {
    en: {
      'Book for': 'Book for',
      'Select days': 'Select days',
      'From the': 'From the',
      'To the': 'To the',
      'Adults': 'Adults',
      'Children': 'Children',
      'Infants': 'Infants',
      'Reservation too short, min. length: ': 'Reservation too short, min. length: ',
      'Maximum number of people: ': 'Maximum number of people: ',
      'No rooms available for this amount of people': 'No rooms available for this amount of people',
      'ages from _years1_': 'ages from _years1_',
      'ages from _years1_ to _years2_': 'ages from _years1_ to _years2_',
      'ages to _years2_': 'ages to _years2_',
      'Adult': 'Adult',
      'Child': 'Child',
      'Infant': 'Infant',
    },
    fr: {
      'ages from _years1_ to _years2_': 'De _years1_ à _years2_ ans',
      'Book for': 'Réserver pour',
      'Adult': 'Adultes',
      'Reservation too short, min. length: ': 'Durée minimale de séjour : ',
      'Adults': 'Adultes',
      'Children': 'Enfants',
      'From the': 'Du',
      'Child': 'Enfants',
      'yes': 'Oui',
      'To the': 'Au',
      'Infant': 'Bébés',
      'ages to _years2_': 'Jusqu\'à _years2_ an(s)',
      'Maximum number of people: ': 'nombre maximal de personnes',
      'Infants': 'Bébés',
      'Select days': 'Rechercher',
      'ages from _years1_': 'Plus de _years1_ ans',
      'No rooms available for this amount of people': 'Une erreur est survenue, veuillez vérifier les conditions (durée minimale de séjour, capacité)',
    },
  }

  const logDebug = (message) => {
    if (process && process.env && process.env.NODE_ENV === 'development') {
      console.log(message)
    }
  }

  this.trans = function(txt) {
    if (this.translations[this.locale] === undefined) {
      return txt
    }
    var ret_str = this.translations[this.locale][txt]
    if (txt in this.translations[this.locale]) {
      return ret_str
    }
    return txt
  }

  this.initJQuery = function(calendar) {
    if (typeof window.jQuery === 'undefined') {
      if (!this.jQueryScriptOutputted) {
        //only output the script once..
        this.jQueryScriptOutputted = true
        loadJS('https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js', () => {
          this.initJQuery(calendar)
        })
      }
    } else if (typeof window.$ === 'undefined') {
      window.$ = window.jQuery
      this.initJQuery(calendar)
    } else if (typeof window.moment === 'undefined') {
      // TODO host this ourselves
      loadJS('https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.17.1/moment-with-locales.js', () => {
        this.initJQuery(calendar)
      })
    } else {
      this.initCalendar(calendar)
    }
  }

  this.getInitData = function(container) {
    this.api_url_root = ''
    this.initial_data_url = '/slugs'
    this.api_url_unavailabilities_base = '/services/yyyyy/unavailabilitycalendar/'
    this.api_url_unavailabilities = ''
    this.api_url_units = '/services/yyyyy/units/'
    this.api_url_offers = '/providers/xxxxx/offers/'
    this.api_url_booking_preview = '/bookings/preview/'
    this.api_url_limits = '/services/yyyyy/conditioncalendar?start=start_date_data&end=end_date_data'
    this.booking_url = ''
    this.booking_url_params = '/service_slug/1?initial_1a_start_date=start_date_data&initial_1a_end_date=end_date_data&initial_2a_adults_number=adults_cnt&initial_2a_children_number=children_cnt&initial_2a_infants_number=infants_cnt'
    this.provider = null
    this.provider_from_api = null
    this.provider_slug = ''
    this.service_from_api = null
    this.service_slug = ''
    this.marketplace_from_api = null
    this.provider = parseInt(container.attr('data-provider'))
    this.service = parseInt(container.attr('data-service'))
    this.api_url_root = API_URL_ROOT
    this.booking_url = container.attr('data-booking-url')
    this.assets_url = ASSETS_URL
    this.css_url = `${this.assets_url}/BMS_calendar.css`
    this.resize_enabled = container.attr('data-resize-enabled') == 'true'
    this.fit_width = container.attr('data-fit-width') == 'true'
    this.fit_height = container.attr('data-fit-height') == 'true'
    this.disable_booking = container.attr('data-disable-booking') == 'true'
    this.data_render_days_only = container.attr('data-render-days-only') == 'true'
    this.api_url_unavailabilities = this.api_url_unavailabilities_base.replace('xxxxx', this.provider).replace('yyyyy', this.service)
    this.color1 = container.attr('data-color1')
    this.color0 = container.attr('data-color0')
    this.color2 = container.attr('data-color2')
    this.color3 = container.attr('data-color3')
    this.color4 = container.attr('data-color4')
    this.exact_nights_number = container.attr('data-exact-nights-number')
    this.mkt_slug = container.attr('data-mkt-slug')
    this.mkt_cname = container.attr('data-mkt-cname')
    this.sales_mode = container.attr('data-sales-mode')
    this.locale = container.attr('data-locale')
    moment.locale(this.locale)
    this.api_url_offers = this.api_url_offers.replace('xxxxx', this.provider).replace('yyyyy', this.service)
    this.api_url_limits = this.api_url_limits.replace('yyyyy', this.service)

    console.log('Booking will be made using base URL: ' + this.booking_url)

    if ($('[data-bms-style=0]').length === 0) {
      $('<style data-bms-style=\'0\' type=\'text/css\'> .bms-calendar-reservation-start-possible{ background-color: ' + this.color0 + ';} </style>').appendTo('head')
      $('<style data-bms-style=\'1\' type=\'text/css\'> .bms-calendar-reservation-possible{ background-color: ' + this.color1 + ';} </style>').appendTo('head')
      $('<style data-bms-style=\'2\' type=\'text/css\'> .bms-calendar-reservation-proposition{ background-color: ' + this.color2 + ';} </style>').appendTo('head')
      $('<style data-bms-style=\'3\' type=\'text/css\'> .bms-calendar-reservation-taken{ background-color: ' + this.color3 + ';} </style>').appendTo('head')
      $('<style data-bms-style=\'4\' type=\'text/css\'> #bms-calendar-container{ background-color: ' + this.color4 + ';} </style>').appendTo('head')
      $('head').append(`<link data-bms-css="1" href="${this.css_url}" rel="stylesheet">`)
    } else {
      $('[data-bms-style=0]').html('.bms-calendar-reservation-start-possible{ background-color: ' + this.color0 + ';}')
      $('[data-bms-style=1]').html('.bms-calendar-reservation-possible{ background-color: ' + this.color1 + ';}')
      $('[data-bms-style=2]').html('.bms-calendar-reservation-proposition{ background-color: ' + this.color2 + ';} ')
      $('[data-bms-style=3]').html('.bms-calendar-reservation-taken{ background-color: ' + this.color3 + ';} ')
      $('[data-bms-style=4]').html(' #bms-calendar-container{ background-color: ' + this.color4 + ';}')
    }

    if (this.data_render_days_only) {
      this.adjustMonthCountDaysOnly()
      this.renderMonthsDaysOnly()
      return
    }

    if (this.disable_booking) {
      this.adjustMonthCountDaysOnly()
      this.getUnavailabilitiesAndRender()
      return
    }

    if (this.service) {
      $.when(
        $.ajax({
          type: 'POST',
          url: this.api_url_root + this.initial_data_url,
          data: JSON.stringify({
            marketplaceSlug: this.mkt_slug,
            serviceId: this.service,
          }),
          contentType: 'application/json',
          dataType: 'json',
          success: (data, status) => {
            this.provider_from_api = data.domain
            this.service_from_api = data.service
            this.service_slug = data.service.slug
            this.marketplace_from_api = data.marketplace
          },
        }),
      ).then(() => {
          this.getPeopleLimits()
        }, () => {
          console.log('API call failed')
        },
      ).always(() => {
          this.renderForm()
          this.getUnavailabilitiesAndRender()
        },
      )
    }
  }

  this.renderMonthsDaysOnly = function() {
    this.months_container.html('')
    this.months.map((item, idx) => {
      if (this.months.length === 1) {
        this.months_container.append(this.getMonthDaysOnly(item.year, item.month, 'both'))
      } else if (idx === 0) {
        this.months_container.append(this.getMonthDaysOnly(item.year, item.month, 'first'))
      } else if (idx === this.months.length - 1) {
        this.months_container.append(this.getMonthDaysOnly(item.year, item.month, 'last'))
      } else {
        this.months_container.append(this.getMonthDaysOnly(item.year, item.month, 'none'))
      }
    })
  }

  this.getMonthDaysOnly = function(year, month, order) {
    //define which days are taken
    var first_day = moment({ year: year, month: month })
    var last_day = moment(first_day).endOf('month').date()
    var container_outer = $('<div class="BMS-calendar-container-month-outer">')
    var container = $('<div class="BMS-calendar-container-month">')
    var day_cnt = 1

    first_day = first_day.weekday()
    if (order === 'first' || order === 'both') {
      container.append($(`
        <div class="BMS-calendar-container-nav BMS-calendar-prev" style="transform:rotate(180deg)">
          <img src="${this.assets_url}/arrow.svg"/>
        </div>
      `).click(() => {
        this.moveMonthsDaysOnly('-')
      }))
    }
    container.append(`<div class="BMS-calendar-month-name">${moment().month(month).format('MMMM')} ${year}</div>`)
    if (order === 'last' || order === 'both') {
      container.append($(`
        <div class="BMS-calendar-container-nav BMS-calendar-next">
          <img src="${this.assets_url}/arrow.svg"/>
        </div>
      `).click(() => {
        this.moveMonthsDaysOnly('+')
      }))
    }

    container_outer.append(this.getMonthDaysDaysOnly(container, first_day, last_day, day_cnt, month, year))
    return container_outer
  }

  this.getMonthDaysDaysOnly = function(container, first_day, last_day, day_cnt, month, year) {
    //render weekdays
    var week = $('<div class="BMS-calendar-container-week"></div>')
    for (let i = 0; i < 7; i++) {
      var day_element = '<div class="BMS-calendar-container-day BMS-calendar-container-day-txt">' + moment(i, 'e').format('ddd') + '</div>'
      week.append(day_element)
    }

    container.append(week)
    //render the rest of the month
    for (let i = 0; i < 6; i++) {
      week = $('<div class="BMS-calendar-container-week"></div>')
      for (let j = 0; j < 7; j++) {
        day_element = $('<div class="BMS-calendar-container-day">')

        if (day_cnt <= last_day && (j >= first_day || i > 0)) {
          day_element.click({ year: year, month: month, day: day_cnt, calendar: this }, this.handleDayDayOnlyClick)
          day_element.text(day_cnt).attr('data-day', day_cnt).attr('data-month', month).attr('data-year', year)
          day_cnt++
        } else {
          day_element.html('&nbsp;')
        }
        week.append(day_element)
      }
      container.append(week)
      if (day_cnt >= last_day) {
        break
      }
    }
    return container
  }

  this.moveMonthsDaysOnly = function(direction) {
    if (direction === '-') {
      this.months.map((item) => {
        item.month -= 1
        if (item.month < 0) {
          item.month = 11
          item.year -= 1
        }
      })
    } else if (direction === '+') {
      this.months.map((item) => {
        item.month += 1
        if (item.month > 11) {
          item.month = 0
          item.year += 1
        }
      })
    }
    this.renderMonthsDaysOnly()
  }

  this.getUnavailabilitiesAndRender = function() {
    var first_month = moment().subtract(1, 'day').startOf('month')
    var last_month = this.months[this.months.length - 1]
    var first_day = first_month.startOf('month').format('YYYY-MM-DD')
    var last_day = moment({ year: last_month.year, month: last_month.month }).endOf('month').format('YYYY-MM-DD')

    $.when(
      $.get(this.api_url_root + this.api_url_unavailabilities, {
          start: first_day,
          end: last_day,
        },
        (data, status) => {
          this.unavailabilities = data[0].calendar
        },
      ),
    ).then(() => {
        this.enforceMinStayLength()
        this.getAvailabilities()
        this.renderMonths()

        if (!this.disable_booking) {
          this.getPossibleEndDays(this.reservation.start)
          this.showCurrentReservation()
        }
      },
    ).fail(() => {
      console.log('failed to get unavailabilities, rendering days anyway')
      this.renderMonths()
    })
  }

  // FIXME need to work on this. Seems it never worked, could be great to have it.
  this.enforceMinStayLength = function() {

  }

  this.getAvailabilities = function() {
    this.availabilities = []
    const availabilities = []
    Object.keys(this.unavailabilities).forEach((date, key) => {
      const dateUnavails = this.unavailabilities[date]

      // Create a first availability.
      if (availabilities.length === 0) {
        let ends_at
        if (dateUnavails.length) {
          ends_at = moment(date).subtract(1, 'day')
        } else {
          ends_at = moment(date)
        }
        availabilities.push({
          starts_at: moment('1900-01-01'),
          ends_at,
        })
      }

      // If there are no unavail, or if every unavail ends at this date,
      // the last availability is updated to end at this date.
      if (dateUnavails.length === 0 || dateUnavails.every(u => moment(u.end).isSame(date, 'day'))) {
        if (availabilities[availabilities.length - 1].starts_at === null) {
          availabilities[availabilities.length - 1].starts_at = moment(date)
        }
        availabilities[availabilities.length - 1].ends_at = moment(date)
      } else if (
        availabilities[availabilities.length - 1].starts_at !== null &&
        key !== (Object.keys(this.unavailabilities).length - 1)
      ) {
        // If there are unavails and they don't end at this date,
        // push a new availability awaiting to be filled.
        availabilities.push({
          starts_at: null,
          ends_at: null,
        })
      }
    })
    logDebug('this.getAvailabilities, availabilities are: ', availabilities)

    // TODO check this, seems to do some shit.
    if (availabilities.length === 0) {
      var last_month = this.months[this.months.length - 1]
      var avail = {
        starts_at: moment('1900-01-01'),
        ends_at: moment({ year: last_month.year, month: last_month.month }).add(1, 'month').endOf('month'),
      }
      availabilities.push(avail)
    }
    // Make sure we didn't add a null unavail
    if (availabilities[availabilities.length - 1].starts_at === null || availabilities[availabilities.length - 1].ends_at === null) {
      availabilities.pop()
    }
    this.availabilities = this.availabilities.concat(availabilities)

  }

  this.getLongestAvail = function(day) {
    var longest = {
      availability: null,
      len: 0,
    }
    this.availabilities.map((avail) => {
      if (day !== null && avail.starts_at.isSameOrBefore(day) && avail.ends_at.isSameOrAfter(day)) {
        if (avail.ends_at.diff(day, 'days') > longest.len) {
          longest.availability = avail
          longest.len = avail.ends_at.diff(day, 'days')
        }
      } else if (day === null) {
        if (avail.ends_at.diff(avail.starts_at, 'days') > longest.len) {
          longest.availability = avail
          longest.len = avail.ends_at.diff(day, 'days')
        }
      }
    })
    return longest
  }

  this.getLastAvailableDay = function(day) {
    var avail = this.getLongestAvail(day)
    return avail.availability.ends_at
  }

  this.getAvailabilityForDay = function(day) {
    return this.availabilities.find(
      avail => avail.starts_at.isSameOrBefore(moment(day)) && avail.ends_at.isSameOrAfter(moment(day)),
    )
  }

  this.getPossibleEndDays = function(day) {
    if (day !== null) {
      const dayDate = moment(day)

      const matchingAvailability = this.getAvailabilityForDay(day)
      const endDates = []

      while (dayDate.isSameOrBefore(matchingAvailability.ends_at)) {
        dayDate.add(1, 'days')

        // TODO enforce minimum stay here.
        if (typeof this.limits.min_booking_duration !== 'undefined' && typeof this.limits.max_booking_duration !== 'undefined') {
          if (
            dayDate.diff(this.reservation.start, 'days') >= this.limits.min_booking_duration &&
            dayDate.diff(this.reservation.start, 'days') <= this.limits.max_booking_duration
          ) {
            endDates.push(dayDate.format('YYYY-MM-DD'))
          }

          logDebug('min booking duration ' + this.limits.min_booking_duration + ' , max booking duration ' + this.limits.max_booking_duration)
        } else {
          endDates.push(dayDate.format('YYYY-MM-DD'))
        }
      }

      if (endDates.length === 0) {
        this.nullifyReservation()
        this.container.find('#bms-calendar-msg').text(this.trans('No rooms available for this amount of people'))
        return
      } else {
        this.container.find('#bms-calendar-msg').text('')
      }
      var
        last_available_day = moment(endDates[endDates.length - 1]),
        last_month = this.months[this.months.length - 1].month,
        last_year = this.months[this.months.length - 1].year,
        last_day = moment({ year: last_year, month: last_month }).endOf('month'),//last day on screen
        tmp_day = moment(day)

      this.container.find('[data-year=' + last_available_day.year() + '][data-month=' + last_available_day.month() + '][data-day=' + last_available_day.date() + ']').removeClass('bms-calendar-reservation-taken')
      this.container.find('[data-year=' + tmp_day.year() + '][data-month=' + tmp_day.month() + '][data-day=' + tmp_day.date() + ']').addClass('bms-calendar-reservation-startend')
      tmp_day = moment(endDates[0])

      // Adds onclick listeners to days that can be an end day for reservation
      // for other days, adds a listener that causes:
      // - clicking on a day which can start the booking (thus overriding previous start),
      // - but not end this one displays end days possible for the new day.
      while (tmp_day.isSameOrBefore(last_day) && tmp_day.isSameOrBefore(last_available_day)) {
        var day_element = this.container.find('[data-year=' + tmp_day.year() + '][data-month=' + tmp_day.month() + '][data-day=' + tmp_day.date() + ']')
        day_element.unbind('click')
        day_element
          .addClass('bms-calendar-reservation-possible')
          .removeClass('bms-calendar-reservation-taken')
          .on('click', { end_day: tmp_day.format('YYYY-MM-DD') }, (event) => {
            this.endReservation(moment(event.data.end_day))
          })
        tmp_day.add(1, 'days')
      }
    }
  }

  this.showCurrentReservation = function() {
    var tmp_day = moment(this.reservation.start)
    var end_day = moment(this.reservation.end)
    this.container.find('[data-year=' + tmp_day.year() + '][data-month=' + tmp_day.month() + '][data-day=' + tmp_day.date() + ']').addClass('bms-calendar-reservation-startend')
    this.container.find('[data-year=' + end_day.year() + '][data-month=' + end_day.month() + '][data-day=' + end_day.date() + ']').addClass('bms-calendar-reservation-startend')
    while (tmp_day.isSameOrBefore(end_day)) {
      this.container.find('[data-year=' + tmp_day.year() + '][data-month=' + tmp_day.month() + '][data-day=' + tmp_day.date() + ']').removeClass('bms-calendar-reservation-possible').removeClass('bms-calendar-reservation-taken')
      this.container.find('[data-year=' + tmp_day.year() + '][data-month=' + tmp_day.month() + '][data-day=' + tmp_day.date() + ']').addClass('bms-calendar-reservation-proposition')
      tmp_day.add(1, 'days')
    }
  }

  this.adjustMonthCount = function() {
    var calendar_width = 316
    var form_width = 195
    var container_width = this.container.width()
    var container_height = this.container.height()
    var month_space_horizontal = Math.floor((container_width - form_width) / calendar_width)
    var month_space_vertical = Math.floor(container_height / calendar_width)
    if (month_space_vertical < 1) {
      month_space_vertical = 1
    }
    var months_on_screen = month_space_horizontal * month_space_vertical
    this.window.width = container_width
    this.window.height = container_height

    var now = moment()
    this.months = [{ year: now.year(), month: now.month() }]

    for (var i = 1; i < months_on_screen; i++) {
      now = now.add(1, 'month')
      this.months.push({ year: now.year(), month: now.month() })
    }
  }

  this.adjustMonthCountDaysOnly = function() {
    var calendar_width = 316
    var container_width = this.container.width()
    var container_height = this.container.height()
    var month_space_horizontal = Math.floor((container_width) / calendar_width)
    var month_space_vertical = Math.floor(container_height / calendar_width)

    var months_on_screen = month_space_horizontal * month_space_vertical

    this.window.width = container_width
    this.window.height = container_height

    var now = moment()
    this.months = [{ year: now.year(), month: now.month() }]

    for (var i = 1; i < months_on_screen; i++) {
      this.months.push({ year: now.year(), month: now.add(1, 'month').month() })
    }
  }

  this.initCalendar = function(calendar) {
    var container = $(calendar)
    this.container = container

    //wait for container to render
    if (container.length === 0) {
      setTimeout(() => {
        this.initCalendar()
      }, 250)
      return 0
    }
    this.container.html('')
    var centering_container = $('<div id="BMS-calendar-centering-container">')
    this.container.append(centering_container)

    this.container.resize(() => {
      if ((Math.abs(this.window.width - this.container.width()) > 100
        || Math.abs(this.window.height - this.container.height()) > 50) && this.resize_enabled
      ) {
        this.adjustMonthCount()
        this.getUnavailabilitiesAndRender()
      }
    })
    var form_container = $('<div class="bms-calendar-form-container">')
    this.form_container = form_container
    centering_container.append(form_container)

    if (this.fit_width) {
      container.css('width', '100%')
    }
    if (this.fit_height) {
      container.css('height', '100%')
    }

    this.adjustMonthCount()
    var months_container = $('<div class="BMS-calendar-container-months">')
    this.months_container = months_container
    centering_container.prepend(months_container)
    this.getInitData(container)
  }

  this.renderMonths = function() {
    this.months_container.html('')
    this.months.map((item, idx) => {
      if (this.months.length === 1) {
        this.months_container.append(this.getMonth(item.year, item.month, 'both'))
      } else if (idx === 0) {
        this.months_container.append(this.getMonth(item.year, item.month, 'first'))
      } else if (idx === this.months.length - 1) {
        this.months_container.append(this.getMonth(item.year, item.month, 'last'))
      } else {
        this.months_container.append(this.getMonth(item.year, item.month, 'none'))
      }
    })
  }

  this.switch_day = function() {
    this.click_switch = !this.click_switch
    this.container.find('.bms-calendar-label-left').each((idx, elem) => {
      this.container.find(elem).toggleClass('bms-calendar-label-selection')
    })
  }

  this.startDay = function() {
    this.click_switch = false
    this.container.find('#bms-calendar-label-from').removeClass('bms-calendar-label-selection')
    this.container.find('#bms-calendar-label-to').addClass('bms-calendar-label-selection')
  }

  this.renderAgeRestrictions = function() {
    var
      age_infant = [null, 2],
      age_child = [3, 14],
      age_adult = [15, null]
    if (this.provider_from_api !== null) {
      age_infant = [null, this.provider_from_api.maxAgeInfant]
      age_child = [this.provider_from_api.maxAgeInfant + 1, this.provider_from_api.maxAgeChild]
      age_adult = [this.provider_from_api.maxAgeChild + 1, null]
    }

    var infants_text = this.trans('ages to _years2_').replace('_years2_', age_infant[1])
    var children_text = this.trans('ages from _years1_ to _years2_')
      .replace('_years1_', age_child[0])
      .replace('_years2_', age_child[1])
    var adults_text = this.trans('ages from _years1_').replace('_years1_', age_adult[0])

    var age_name = $('<span id="BMS-calendar-adult-descr" class="BMS-calendar-age-name">').text(this.trans('Adult'))
    var age_range = $('<span class"BMS-calendar-age-info">').text(' ' + adults_text)
    this.container.find('#bms-calendar-age-info-adult').html(age_name).append(age_range)

    age_name = $('<span id="BMS-calendar-child-descr" class="BMS-calendar-age-name">').text(this.trans('Child'))
    age_range = $('<span class"BMS-calendar-age-info">').text(' ' + children_text)
    this.container.find('#bms-calendar-age-info-child').html(age_name).append(age_range)

    age_name = $('<span id="BMS-calendar-infant-descr" class="BMS-calendar-age-name">').text(this.trans('Infant'))
    age_range = $('<span class"BMS-calendar-age-info">').text(' ' + infants_text)
    this.container.find('#bms-calendar-age-info-infant').html(age_name).append(age_range)
  }

  this.renderForm = function() {
    var container = this.container.find('.bms-calendar-form-container')
    container.html('')
    container.append($('<div class="row bms-calendar-dates-row"><label id="bms-calendar-label-from" class="bms-calendar-label-left bms-calendar-label-selection" for="bms-calendar-from">' + this.trans('From the') + ':&nbsp;</label><div id="bms-calendar-from">&nbsp;</div></div>'))
    container.append($('<div class="row bms-calendar-dates-row" ><label id="bms-calendar-label-to" class="bms-calendar-label-left" for="bms-calendar-to">' + this.trans('To the') + ':&nbsp;</label><div id="bms-calendar-to">&nbsp;</div></div>'))
    container.append($('<div class="row bms-calendar-dates-row" ><div id="bms-calendar-msg"></div></div>'))
    container.append($('<div class="row"><div class="bms-calendar-input_box"><div class="bms-calendar-age-limit-container"><button id="bms-calendar-adults-minus" class="guest-qty-button">-</button><span id="bms-calendar-adults" class="guest-qty">' + this.adults + '</span><button  id="bms-calendar-adults-plus" class="guest-qty-button">+</button></div><label class="bms-calendar-label-right" for="bms-calendar-adults">'
      + '<span id="bms-calendar-age-info-adult" class="bms-calendar-age-info"></span>'
      + '</label></div></div>'))
    container.append($('<div class="row"><div class="bms-calendar-input_box"><div class="bms-calendar-age-limit-container"><button id="bms-calendar-children-minus" class="guest-qty-button">-</button><span id="bms-calendar-children" class="guest-qty">' + this.children + '</span><button  id="bms-calendar-children-plus" class="guest-qty-button">+</button></div><label class="bms-calendar-label-right" for="bms-calendar-children">'
      + '<span id="bms-calendar-age-info-child" class="bms-calendar-age-info"></span>'
      + '</label></div></div>'))
    container.append($('<div class="row"><div class="bms-calendar-input_box"><div class="bms-calendar-age-limit-container" ><button id="bms-calendar-infants-minus" class="guest-qty-button">-</button><span id="bms-calendar-infants" class="guest-qty">' + this.infants + '</span><button  id="bms-calendar-infants-plus" class="guest-qty-button">+</button></div><label class="bms-calendar-label-right" for="bms-calendar-infants">'
      + '<span id="bms-calendar-age-info-infant" class="bms-calendar-age-info"></span>'
      + '</label></div></div>'))
    container.append($('<div class="row"><button id="bms-calendar-book-button" class="bms-calendar-book btn bms-calendar-reservation-proposition" >' + this.trans('Select days') + '</button><div>')
      .click(() => this.book()))

    //this.form_container.append(container);

    this.container.find('#bms-calendar-adults-plus').click((event) => {
      this.setAdultsCount(this.adults + 1)
    })
    this.container.find('#bms-calendar-adults-minus').click((event) => {
      this.setAdultsCount(this.adults - 1)
    })
    this.container.find('#bms-calendar-children-plus').click((event) => {
      this.setChildrenCount(this.children + 1)
    })
    this.container.find('#bms-calendar-children-minus').click((event) => {
      this.setChildrenCount(this.children - 1)
    })
    this.container.find('#bms-calendar-infants-plus').click((event) => {
      this.setInfantsCount(this.infants + 1)
    })
    this.container.find('#bms-calendar-infants-minus').click((event) => {
      this.setInfantsCount(this.infants - 1)
    })
    this.renderAgeRestrictions()
  }

  this.moveMonths = function(direction) {
    if (direction === '-') {
      this.months.map(function(item) {
        item.month -= 1
        if (item.month < 0) {
          item.month = 11
          item.year -= 1
        }
      })
    }
    if (direction === '+') {
      this.months.map(function(item) {
        item.month += 1
        if (item.month > 11) {
          item.month = 0
          item.year += 1
        }
      })
    }
    this.getUnavailabilitiesAndRender()
  }

  this.processUnavailabilities = function(first_day) {
    var
      monthStart = first_day.startOf('month'),
      monthEnd = moment(first_day).endOf('month'),
      monthUnavailabilities = []

    const currentDay = monthStart.clone()

    // Iterate over each day until the end of month.
    while (currentDay.isBefore(monthEnd, 'day')) {
      // Find at least 1 availability that starts before or exactly at this date, and ends after or exactly at this date.
      const matchingAvail = this.availabilities.find(
        avail => avail.starts_at.isSameOrBefore(currentDay) && avail.ends_at.isSameOrAfter(currentDay),
      )
      monthUnavailabilities[currentDay.date()] = matchingAvail ? 0 : 1
      // Increment index and day.
      currentDay.add(1, 'days')
    }
    //enforce minimum stay length
    return monthUnavailabilities
  }

  this.getMonth = function(year, month, order) {
    //define which days are taken
    var first_day = moment({ year: year, month: month })
    var last_day = moment(first_day).endOf('month').date()
    var unavailabilities = this.processUnavailabilities(first_day)
    var container_outer = $('<div class="BMS-calendar-container-month-outer">')
    var container = $('<div class="BMS-calendar-container-month">')

    var day_cnt = 1
    moment.locale('fr')
    first_day = first_day.isoWeekday() - 1
    if (order === 'first' || order === 'both') {
      container.append($(`
      <div class="BMS-calendar-container-nav BMS-calendar-prev" style="transform:rotate(180deg)">
        <img src="${this.assets_url}/arrow.svg"/>
      </div>
      `).click(() => {
        this.moveMonths('-')
      }))
    }
    moment.locale(this.locale)
    container.append('<div class="BMS-calendar-month-name">' + moment().month(month).format('MMMM') + ' ' + year + '</div>')
    moment.locale('fr')
    if (order === 'last' || order === 'both') {
      container.append($(`
        <div class="BMS-calendar-container-nav BMS-calendar-next" style="">
          <img src="${this.assets_url}/arrow.svg"/>
        </div>
      `).click(() => {
        this.moveMonths('+')
      }))
    }
    container_outer.append(this.getMonthDays(container, first_day, last_day, day_cnt, month, year, unavailabilities))
    return container_outer
  }

  this.getMonthDays = function(container, first_day, last_day, day_cnt, month, year, unavailabilities) {
    //render weekdays
    var week = $('<div class="BMS-calendar-container-week"></div>')
    moment.locale(this.locale)
    for (let i = 1; i < 8; i++) {
      var day_element = '<div class="BMS-calendar-container-day BMS-calendar-container-day-txt">' + moment(i, 'E').format('ddd') + '</div>'
      week.append(day_element)
    }
    moment.locale('fr')
    var today = moment()
    container.append(week)

    //render the rest of the month
    for (let i = 0; i < 6; i++) {
      week = $('<div class="BMS-calendar-container-week"></div>')
      for (let j = 0; j < 7; j++) {
        day_element = $('<div class="BMS-calendar-container-day">')

        if (day_cnt <= last_day && (j >= first_day || i > 0) && this.provider_from_api !== null) {
          var this_day = moment({ year: year, month: month, day: day_cnt, hour: '18' })
          if (
            unavailabilities[day_cnt] !== 0 ||
            this_day.isBefore(today) ||
            this_day.diff(today, 'hours') >= this.provider_from_api.maxHoursBeforeBooking ||
            this_day.diff(today, 'hours') <= this.provider_from_api.minHoursBeforeBooking
          ) {
            day_element.addClass('bms-calendar-reservation-taken')
          } else {
            day_element.addClass('bms-calendar-reservation-start-possible')
              .click({ year: year, month: month, day: day_cnt, calendar: this }, this.handleDayClick.bind(this))
          }
          day_element.text(day_cnt).attr('data-day', day_cnt).attr('data-month', month).attr('data-year', year)
          day_cnt++
        } else {
          day_element.html('&nbsp;')
        }
        week.append(day_element)
      }
      container.append(week)
      if (day_cnt >= last_day + 1) {
        break
      }
    }
    return container
  }

  this.getBookingUrl = function() {
    var booking_url = ''
    var booking_params_url_prefix = ''

    if (['en', 'fr', 'nl', 'de'].includes(this.locale)) {
      booking_params_url_prefix = '/' + this.locale
    }
    booking_params_url_prefix += '/mkt/' + this.mkt_slug

    if (this.mkt_cname) {
      booking_url = this.mkt_cname
    } else {
      booking_url = this.booking_url
    }

    booking_url = booking_url + booking_params_url_prefix + this.booking_url_params
    return booking_url
  }

  this.book = function() {
    if (!this.checkPeopleLimits()) {
      if (this.reservation.start !== null && this.reservation.end !== null) {
        var booking_url = this.getBookingUrl()
        var url = encodeURI(
          booking_url
            .replace('service_slug', this.service_slug)
            .replace('adults_cnt', this.adults)
            .replace('children_cnt', this.children)
            .replace('infants_cnt', this.infants)
            .replace('start_date_data', this.reservation.start.format('YYYY-MM-DD'))
            .replace('end_date_data', this.reservation.end.format('YYYY-MM-DD')),
        )
        console.log(`Booking, URL is ${url}`)
        window.open(url)
      }
    }
  }

  this.setAdultsCount = function(count) {
    if (count >= 1) {
      this.adults = count
      this.container.find('#bms-calendar-adults').text(this.adults)
    } else {
      this.adults = 1
    }

    if (!this.checkPeopleLimits()) {
      this.getBookingPreview()
    }
  }

  this.setChildrenCount = function(count) {
    if (count >= 0) {
      this.children = count
      this.container.find('#bms-calendar-children').text(this.children)
    } else {
      this.children = 0
    }

    if (!this.checkPeopleLimits()) {
      this.getBookingPreview()
    }
  }
  this.setInfantsCount = function(count) {
    if (count >= 0) {
      this.infants = count
      this.container.find('#bms-calendar-infants').text(this.infants)
    } else {
      this.infants = 0
    }
    if (!this.checkPeopleLimits()) {
      this.getBookingPreview()
    }
  }

  this.handleDayClick = function(event) {
    var CALENDAR = event.data.calendar

    var start_date = moment({ year: event.data.year, month: event.data.month, day: event.data.day })
    if (!CALENDAR.disable_booking && CALENDAR.adults > 0 && !CALENDAR.checkPeopleLimits()) {
      if (CALENDAR.reservation.start === null) {
        CALENDAR.startReservation(start_date)
        CALENDAR.getPossibleEndDays(start_date)
        CALENDAR.startDay()
      } else {
        //if click is outside of possible end days
        let avail = CALENDAR.getLongestAvail(CALENDAR.reservation.start)
        if (avail.availability.ends_at.isBefore(start_date)
          || avail.availability.starts_at.isAfter(start_date)
          || start_date.isBefore(CALENDAR.reservation.start)) {
          CALENDAR.startDay()
          CALENDAR.reservation.end = null
          CALENDAR.container.find('#bms-calendar-to').text('')
          CALENDAR.renderMonths()
          CALENDAR.startReservation(start_date)
          CALENDAR.getPossibleEndDays(start_date)
        }
      }
    } else if (this.checkPeopleLimits()) {
      CALENDAR.nullifyReservation()
      CALENDAR.renderMonths()
      CALENDAR.startReservation(start_date)
      CALENDAR.getPossibleEndDays(start_date)
      CALENDAR.startDay()
    }
  }

  //false if amounts are ok
  this.checkPeopleLimits = function() {
    var changed = false
    this.container.find('#BMS-calendar-adult-descr').text(this.trans('Adult'))
    this.container.find('#BMS-calendar-child-descr').text(this.trans('Child'))
    this.container.find('#BMS-calendar-infant-descr').text(this.trans('Infant'))
    if (!!this.limits.max_adults && this.limits.max_adults < this.adults) {
      this.container.find('#BMS-calendar-adult-descr').text(this.trans('Adult') + ' max. ' + this.limits.max_adults)
      changed = true
    }
    if (!!this.limits.max_children && this.limits.max_children < this.children) {
      this.container.find('#BMS-calendar-child-descr').text(this.trans('Child') + ' max. ' + this.limits.max_children)
      changed = true
    }
    if (!!this.limits.max_infants && this.limits.max_infants < this.infants) {
      this.container.find('#BMS-calendar-infant-descr').text(this.trans('Infant') + ' max. ' + this.limits.max_infants)
      changed = true
    }
    this.container.find('#bms-calendar-msg').html('')
    if (!!this.limits.max_people && this.limits.max_people < this.adults + this.children + this.infants) {
      this.container.find('#bms-calendar-msg').text(this.trans('Maximum number of people: ' + this.limits.max_people))
      changed = true
    }
    if (typeof this.limits.min_booking_duration !== 'undefined') {
      if (
        this.limits.min_booking_duration > 0 &&
        this.reservation.end &&
        this.reservation.end.diff(this.reservation.start, 'days') >= 0 &&
        this.limits.min_booking_duration > this.reservation.end.diff(this.reservation.start, 'days')
      ) {
        this.container.find('#bms-calendar-msg').text(this.trans('Reservation too short, min. length: ') + this.limits.min_booking_duration + this.trans(' days.'))
        changed = true
      }
      if (
        this.limits.max_booking_duration < 1000 &&
        this.reservation.end &&
        this.reservation.end.diff(this.reservation.start, 'days') >= 0 &&
        this.limits.max_booking_duration <= this.reservation.end.diff(this.reservation.start, 'days')
      ) {
        this.container.find('#bms-calendar-msg').text(this.trans('Reservation too long, max. length: ') + this.limits.max_booking_duration + this.trans(' days.'))
        changed = true
      }
    }
    return changed
  }

  this.getPeopleLimits = function() {
    this.limits = {
      max_people: this.service_from_api.maxPeopleAllowed,
      max_adults: this.service_from_api.maxAdultsAllowed,
      max_children: this.service_from_api.maxChildrenAllowed,
      max_infants: this.service_from_api.maxInfantAllowed,
    }
    if (!this.reservation.start) {
      return
    }

    // If we only have start date (eg. first click on a day),
    // we'll just get the conditions applying to start day and the day after.
    const url = this.api_url_root + this.api_url_limits
      .replace('start_date_data', this.reservation.start.format('YYYY-MM-DD'))
      .replace(
        'end_date_data',
        this.reservation.end
          ? this.reservation.end.format('YYYY-MM-DD')
          : this.reservation.start.clone().add(1, 'days').format('YYYY-MM-DD'))

    $.get(url, (data, status) => {
      let minBookingDuration = 0
      let maxBookingDuration = 1000

      Object.keys(data).filter(date => data[date] !== null).forEach((date) => {
        const condition = data[date]
        if (condition.minBookingDuration && (minBookingDuration === 0 || condition.minBookingDuration > minBookingDuration)) {
          minBookingDuration = condition.minBookingDuration
        }
        if (condition.maxBookingDuration && (maxBookingDuration === 1000 || condition.maxBookingDuration < maxBookingDuration)) {
          maxBookingDuration = condition.maxBookingDuration
        }
      })
      this.limits = {
        ...this.limits,
        min_booking_duration: minBookingDuration,
        max_booking_duration: maxBookingDuration,
      }
    })
  }

  this.updateReservation = function(reservation) {
    this.reservation = reservation
  }

  //this shows possible days for the end of reservation
  this.startReservation = function(start_date) {
    //$('[data-year='+start_date.year()+'][data-month='+start_date.month()+'][data-day='+start_date.date()+']').addClass('bms-calendar-reservation-possible');
    this.reservation.start = start_date
    this.reservation.end = null
    this.container.find('#bms-calendar-from').text(this.reservation.start.format('DD/MM/YYYY'))
    this.container.find('#bms-calendar-to').text('')
    this.getPeopleLimits()
    //display longest availability that starts with the selected day
  }
  this.nullifyReservation = function() {
    //$('[data-year='+start_date.year()+'][data-month='+start_date.month()+'][data-day='+start_date.date()+']').addClass('bms-calendar-reservation-possible');
    this.reservation.start = null
    this.container.find('#bms-calendar-from').text('')
    this.container.find('#bms-calendar-to').text('')
    //display longest availability that starts with the selected day
  }

  this.endReservation = function(end_date) {
    var today = moment()
    if (
      this.click_switch &&
      end_date.diff(today, 'hours') > this.provider_from_api.minHoursBeforeBooking
    ) {
      this.renderMonths()
      this.startReservation(end_date)
      this.getPossibleEndDays(end_date)
    } else {
      this.reservation.end = end_date
      this.container.find('#bms-calendar-to').text(this.reservation.end.format('DD/MM/YYYY'))
      this.renderMonths()
      this.getPeopleLimits()
      if (!this.checkPeopleLimits()) {
        this.getBookingPreview()
        this.getPossibleEndDays(this.reservation.start)
        this.showCurrentReservation()
      }
    }
    this.switch_day()
  }

  this.getBookingPreview = function() {
    var url = this.api_url_root + this.api_url_booking_preview

    if (this.reservation.start !== null && this.reservation.end !== null) {
      $.ajax({
        type: 'POST',
        url,
        data: JSON.stringify({
          service: this.service_from_api.id,
          marketplace: this.marketplace_from_api.id,
          start: this.reservation.start.format('YYYY-MM-DD'),
          end: this.reservation.end.format('YYYY-MM-DD'),
          adults: parseInt(this.adults),
          children: parseInt(this.children),
          infants: parseInt(this.infants),
        }),
        contentType: 'application/json',
        dataType: 'json',
        success: (data, status) => {
          this.container.find('#bms-calendar-book-button').html(this.trans('Book for') + ' ' + (data.totalChargeWithDiscounts.amount / 100) + '&#8364;')
        },
      })
    }
  }

  this.showPossibleEndDaysDaysOnly = function(day) {
    var tmp_day = moment(day)
    var day_element = this.container.find('[data-year=' + day.year() + '][data-month=' + tmp_day.month() + '][data-day=' + tmp_day.date() + ']')
    day_element.unbind('click')
    day_element.addClass('bms-calendar-reservation-possible')
  }

  this.handleDayDayOnlyClick = function(e) {
    var CALENDAR = e.data.calendar
    var click_date = moment({ year: e.data.year, month: e.data.month, day: e.data.day })
    if (CALENDAR.exact_nights_number) {
      CALENDAR.reservation.start = click_date
      CALENDAR.reservation.end = moment(click_date).add(CALENDAR.exact_nights_number, 'days')
      CALENDAR.renderMonthsDaysOnly()
      CALENDAR.showCurrentReservation()
      let data = {
        calendar: CALENDAR,
        day: parseInt(CALENDAR.reservation.end.format('D')),
        month: parseInt(CALENDAR.reservation.end.format('M')) - 1,
        year: parseInt(CALENDAR.reservation.end.format('YYYY')),
      }
      $(document).trigger({ type: 'bms-calendar-start-day-clicked', calendar_data: e.data })
      $(document).trigger({ type: 'bms-calendar-end-day-clicked', calendar_data: data })
    } else {
      if (CALENDAR.reservation.start === null || click_date.isSameOrBefore(CALENDAR.reservation.start) || !CALENDAR.click_switch) {
        CALENDAR.reservation.end = null
        CALENDAR.startReservation(click_date)
        CALENDAR.renderMonthsDaysOnly()
        CALENDAR.showPossibleEndDaysDaysOnly(click_date)
        $(document).trigger({ type: 'bms-calendar-start-day-clicked', calendar_data: e.data })
      } else {
        CALENDAR.reservation.end = click_date
        CALENDAR.renderMonthsDaysOnly()
        CALENDAR.showCurrentReservation()
        $(document).trigger({ type: 'bms-calendar-end-day-clicked', calendar_data: e.data })
      }
    }
    CALENDAR.switch_day()
    $(document).trigger({ type: 'bms-calendar-day-clicked', calendar_data: e.data })
  }
}

function initCalendars(calendars) {
  [].forEach.call(calendars, function(calendar) {
    window.BMS_CALENDAR = new BMS_calendar()
    window.BMS_CALENDAR.initJQuery(calendar)
  })
}

if (window.calendarPreview) {
  const calendar = document.querySelector('#bms-calendar-container')
  window.BMS_CALENDAR = new BMS_calendar()
  window.BMS_CALENDAR.initJQuery(calendar)
} else {
  window.addEventListener('load', function() {
    window.BMS_CALENDAR = null
    let calendars = document.querySelectorAll('#bms-calendar-container')
    if (!calendars.length) {
      let i = 1
      var getCalendars = setInterval(function() {
        calendars = document.querySelectorAll('#bms-calendar-container')
        if (!calendars.length && i < 10) {
          i++
        } else {
          clearInterval(getCalendars)
          initCalendars(calendars)
        }
      }, 3000)
    } else {
      initCalendars(calendars)
    }
  }, false)
}
